import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Event Directory",
    href: "/event-registration/events",
    icon: CalendarDaysIcon,
    current: false,
    internalName: "event-directory",
    permissions: ["administration-events"],
    isCertainPathOnly: true,
  },
];

const eventRegistrationConfig = {
  sectionName: "event-registration",
  defaultRoute: "/event-registration/events",
  navigation,
};

export default eventRegistrationConfig;
